import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import customer_edit from "../../assets/images/admin/customer_edit.svg";
import { apiUrl } from "../../config/Config";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Customers = () => {
  const navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const paginationPageSizeSelector = useMemo(() => [10, 20, 50, 100], []);

  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userdata?.token,
    },
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return "NA";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dateValue;
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  const fetchCustomers = async () => {
    setLoading(true);
    await axios
      .post(apiUrl + "getadmincustomers", {}, headers)
      .then((res) => {
        if (res.data.status === "success") {
          setCustomers(Array.isArray(res.data.data) ? res.data.data : []);
        } else {
          Swal.fire({
            text: res.data.message,
            icon: "error",
            confirmButtonColor: "rgb(59, 151, 196)",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: err.message,
          icon: "error",
          confirmButtonColor: "rgb(59, 151, 196)",
        });
      });
    setLoading(false);
  };

  useEffect(() => {
    if (userdata && Object.keys(userdata).length > 0) {
      fetchCustomers();
    } else {
      navigate("/admin/login");
    }
  }, []);

  const rowData = useMemo(
    () =>
      customers.map((customer) => ({
        id: customer.id,
        name: customer.fullname || "Customer",
        email: customer.email || "NA",
        phoneNumber: customer.number || "NA",
        orders: customer.orders_count || 0,
        questions: customer.questions_count || 0,
        refunds: customer.refunds_count || 0,
        created: formatDate(customer.created_at),
        status: customer.status || "true",
      })),
    [customers]
  );

  const colDefs = useMemo(
    () => [
      {
        field: "name",
        headerName: "Name",
        filter: true,
        cellRenderer: (props) => (
          <button
            className="admin-link-cell"
            onClick={() => navigate(`/admin/customer-details/${props.data.id}`)}
          >
            {props.data.name}
          </button>
        ),
      },
      { field: "email", headerName: "Email", filter: true },
      { field: "phoneNumber", headerName: "Phone", filter: true },
      { field: "orders", headerName: "Orders", width: 120 },
      { field: "questions", headerName: "Questions", width: 130 },
      { field: "refunds", headerName: "Refunds", width: 120 },
      { field: "created", headerName: "Created" },
      {
        field: "action",
        headerName: "Action",
        width: 110,
        cellRenderer: (props) => (
          <div className="d-flex" style={{ display: "flex", marginTop: 7 }}>
            <div className="customet_table_icon_div" onClick={() => navigate(`/admin/customer-details/${props.data.id}`)}>
              <img src={customer_edit} className="customet_table_icon" alt="" />
            </div>
          </div>
        ),
      },
    ],
    [navigate]
  );

  return (
    <div>
      <div className="dashboardbox" style={{ width: "100%" }}>
        <p className="dashboardboxsubtitle">
          {loading ? "Loading customers..." : `${rowData.length} customers found`}
        </p>
        <div className="ag-theme-quartz mt-4" style={{ width: "100%", height: 550 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={{ flex: 1 }}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            rowHeight={50}
          />
        </div>
      </div>
    </div>
  );
};

export default Customers;
